import { render, staticRenderFns } from "./H5Checkandreceive.vue?vue&type=template&id=22252622&scoped=true&"
import script from "./H5Checkandreceive.vue?vue&type=script&lang=js&"
export * from "./H5Checkandreceive.vue?vue&type=script&lang=js&"
import style0 from "./H5Checkandreceive.vue?vue&type=style&index=0&id=22252622&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22252622",
  null
  
)

export default component.exports